export default {
  methods: {
    initialFromModel(modelValue, value, fallback) {
      return modelValue !== undefined
        ? modelValue
        : value !== undefined
        ? value
        : fallback;
    },
    emitModel(val) {
      this.$emit("input", val);
      this.$emit("update:modelValue", val);
      this.$emit("change", val);
    },
  },
};
